import type { SupportTicket } from "../RequestData";

/**
 * Query param that opens one ticket's detail when the page loads, as in the
 * link of a participant email: `/kontrol/support/request?ticket=KS-1660`
 * (CTX-1343).
 */
export const TICKET_LINK_PARAM = "ticket";

/**
 * The row a link points at, by the number the list shows (`KS-1660`) or by
 * its id, ignoring case. Undefined when the ticket is not in the user's list.
 */
export function findLinkedTicket(
  tickets: SupportTicket[],
  ticketRef: string
): SupportTicket | undefined {
  const wanted = ticketRef.trim().toLowerCase();
  if (!wanted) return undefined;
  return tickets.find(
    (t) =>
      String(t.key ?? "").toLowerCase() === wanted ||
      String(t.id).toLowerCase() === wanted
  );
}
